var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_vm._v("员工入职")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-30px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "650px",
      "background-color": "white",
      "margin": "10px 40px 0 40px",
      "padding": "50px 100px",
      "overflow-x": "hidden"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px",
      "width": "80%"
    },
    attrs: {
      "label": "姓名",
      "prop": "staff.staff_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.ruleForm.staff.staff_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_name", $$v)
      },
      expression: "ruleForm.staff.staff_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "label": "性别",
      "prop": "staff.staff_gender"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.ruleForm.staff.staff_gender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_gender", $$v)
      },
      expression: "ruleForm.staff.staff_gender"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.ruleForm.staff.staff_gender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_gender", $$v)
      },
      expression: "ruleForm.staff.staff_gender"
    }
  }, [_vm._v("女")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号码",
      "prop": "staff.staff_card"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入身份证号码"
    },
    model: {
      value: (_vm.ruleForm.staff.staff_card),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_card", $$v)
      },
      expression: "ruleForm.staff.staff_card"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "staff.staff_telephone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.ruleForm.staff.staff_telephone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "staff_telephone", $$v)
      },
      expression: "ruleForm.staff.staff_telephone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "本人照片"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "show-file-list": false,
      "on-success": _vm.handleStaffTelephoneSuccess
    }
  }, [(_vm.ruleForm.staff.staff_photo) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.ruleForm.staff.staff_photo
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证原件相片",
      "prop": "staff.card_photo"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "show-file-list": false,
      "on-success": _vm.handleCardPhotoSuccess
    }
  }, [(_vm.ruleForm.staff.card_photo) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.ruleForm.staff.card_photo
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "银行卡号"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入银行卡号"
    },
    model: {
      value: (_vm.ruleForm.staff.bank_no),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "bank_no", $$v)
      },
      expression: "ruleForm.staff.bank_no"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "开户行"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择开户行",
      "clearable": ""
    },
    model: {
      value: (_vm.ruleForm.staff.opening_bank),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "opening_bank", $$v)
      },
      expression: "ruleForm.staff.opening_bank"
    }
  }, _vm._l((_vm.causeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.bank_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "银行卡照片"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "show-file-list": false,
      "on-success": _vm.handleBankPhotoSuccess
    }
  }, [(_vm.ruleForm.staff.bank_photo) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.ruleForm.staff.bank_photo
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-weight": "900",
      "font-size": "20px"
    }
  }, [_vm._v("| ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "20px",
      "font-weight": "700"
    }
  }, [_vm._v("入职信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "组织架构",
      "prop": "staff.organize_temporary_ids"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "collapse-tags": "",
      "props": _vm.props
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.ruleForm.staff.organize_temporary_ids),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "organize_temporary_ids", $$v)
      },
      expression: "ruleForm.staff.organize_temporary_ids"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "城市",
      "prop": "staff.city_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.staff.city_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "city_id", $$v)
      },
      expression: "ruleForm.staff.city_id"
    }
  }, _vm._l((_vm.$globals.cityList), function(item) {
    return _c('el-option', {
      key: item.city,
      attrs: {
        "label": item.city,
        "value": item.city
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "职位",
      "prop": "staff.post_id"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.staff.post_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm.staff, "post_id", $$v)
      },
      expression: "ruleForm.staff.post_id"
    }
  }, _vm._l((_vm.gwlist), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.post_name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "入职日期",
      "prop": "induction_time"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.ruleForm.induction_time),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "induction_time", $$v)
      },
      expression: "ruleForm.induction_time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "入职薪酬",
      "prop": "induction_salary"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请输入入职薪酬"
    },
    model: {
      value: (_vm.ruleForm.induction_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "induction_salary", $$v)
      },
      expression: "ruleForm.induction_salary"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "试用期时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "47%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.trial_start),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "trial_start", $$v)
      },
      expression: "ruleForm.trial_start"
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\t—\n\t\t\t\t\t\t\t\t"), _c('el-date-picker', {
    staticStyle: {
      "width": "47%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.trial_end),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "trial_end", $$v)
      },
      expression: "ruleForm.trial_end"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "是否有试用期"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.ruleForm.is_trial),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "is_trial", $$v)
      },
      expression: "ruleForm.is_trial"
    }
  }, _vm._l((_vm.option), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "入职添加日期"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.ruleForm.induction_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "induction_date", $$v)
      },
      expression: "ruleForm.induction_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "试用期薪资"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请输入试用期薪资"
    },
    model: {
      value: (_vm.ruleForm.trial_salary),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "trial_salary", $$v)
      },
      expression: "ruleForm.trial_salary"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "入职资料套表"
    }
  }, [_c('el-button', {
    staticStyle: {
      "font-size": "10px",
      "height": "30px",
      "text-align": "center"
    },
    attrs: {
      "size": "small",
      "type": "goon"
    }
  }, [_vm._v("下载附件")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "签约合同上传"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "multiple": "",
      "file-list": _vm.fileList,
      "on-success": _vm.handleAvatarSuccess,
      "on-remove": _vm.handleRemove
    }
  }, [_c('el-button', {
    staticStyle: {
      "font-size": "10px",
      "height": "30px",
      "text-align": "center"
    },
    attrs: {
      "size": "small",
      "type": "goon"
    }
  }, [_vm._v("附件上传")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "200px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id === null || _vm.ruleForm.id === ''),
      expression: "ruleForm.id === null || ruleForm.id === ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.isBlacklist()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Update()
      }
    }
  }, [_vm._v("修改")])], 1)], 1)], 1)])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-103db5a4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/Ygrz/Ygrz_add.vue
// module id = null
// module chunks = 